import { Error } from '../../error';
import { Input } from '../../input';

export const PatternInput = ({ params, onChange, errors }) => (
  <div>
    <Input
      label="URL Pattern"
      help="URL pattern to crawl for, must contain at least one wildcard (*) operator."
      style={{ width: '100%', maxWidth: 600 }}
      value={params.pattern}
      onChange={(e) => onChange('pattern', e.target.value)}
      placeholder={`https://example.com/category/*`}
    />
    <Error small message={errors?.pattern} />
  </div>
);
